import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { LottieSettings } from '@finder/shared/components/lottie/lottie.interface';
import { LottieComponent } from '../lottie/lottie.component';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';

@Component({
    selector: 'finder-text-logo',
    templateUrl: './text-logo.component.html',
    styleUrls: ['./text-logo.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        LottieComponent,
        SafeHtmlPipe,
    ]
})
export class TextLogoComponent {
    @Input() id: string;
    @Input() lottie: LottieSettings;
    @Input() a11yText: string;

    constructor() { }
}
